import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.object.values.js";
import { isRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { useActionTypeContextStore } from "./ActionTypeContext";
import { useBrandQuickActions } from "./useBrandQuickActions";
import { useRetailerQuickActions } from "./useRetailerQuickActions";
export var useActionTypes = function useActionTypes() {
  var _useActionTypeContext = useActionTypeContextStore(["actionType"]),
    _useActionTypeContext2 = _slicedToArray(_useActionTypeContext, 2),
    actionType = _useActionTypeContext2[0].actionType,
    setActionTypeContextStore = _useActionTypeContext2[1];
  var retailerQuickActions = useRetailerQuickActions();
  var brandQQuickActions = useBrandQuickActions();
  var actions = isRetailer() ? retailerQuickActions : brandQQuickActions;
  var actionTypes = Object.values(actions);
  var clearActionType = function clearActionType() {
    setActionTypeContextStore({
      actionType: undefined
    });
  };
  var setActionType = function setActionType(actionType) {
    setActionTypeContextStore({
      actionType: actionType
    });
  };
  return {
    actionTypes: actionTypes,
    clearActionType: clearActionType,
    actionType: actionType,
    setActionType: setActionType
  };
};